<template>
  <div class="content">
    <div class="layout">
      <div class="text-end mb-3">
        <select
          v-model="selectedLang"
          @change="onLangChange"
          class="form-select w-auto d-inline-block"
        >
          <option v-for="lang in languages" :key="lang.code" :value="lang.code">
            {{ lang.language }}
          </option>
        </select>

        <select
          v-model="selectedCountry"
          @change="onCountryChange"
          class="form-select w-auto d-inline-block"
        >
          <option value="" disabled>Select Country</option>
          <option
            v-for="count in countries"
            :key="count.code"
            :value="count.code"
          >
            {{ count.country }}
          </option>
        </select>
      </div>
      <div class="justify-content-center">
        <div style="width: 100%; max-width: 100%">
          <div
            ref="editor"
            class="ckeditor"
            style="width: 100%; border: 1px solid #ddd; padding: 10px"
          ></div>
        </div>
      </div>

      <div class="text-center my-3">
        <div class="row">
          <div class="col"></div>
          <!-- <div class="col">
            <button
              type="button"
              class="btn btn-warning"
              @click="updateContent"
            >
              Update Licence
            </button>
          </div> -->
          <div class="text-end col">
            <button
              type="button"
              class="btn btn-primary"
              @click="publishContent"
            >
              <span v-if="loading">Loading...</span>
              <span v-else> Publish Content</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "../services/api";
import Cookies from "js-cookie";

export default {
  data() {
    return {
      selectedLang: "en", // default language
      // selectedLanguage: "",
      loading: false,
      quill: null, // Store the Quill editor instance
      content: "", // Store the editor content
      languages: [],
      selectedCountry: "CG",
      countries: [],
    };
  },
  watch: {
    selectedLang(newLang) {
      this.getContent(newLang, this.selectedCountry);
    },
    selectedCountry(newCountry) {
      this.getContent(this.selectedLang, newCountry);
    },
  },
  mounted() {
    this.getLanguages();
    this.getCountries();

    // Initialize Quill editor
    this.quill = new Quill(this.$refs.editor, {
      theme: "snow",
      placeholder: "Type here...",
    });

    // Listen for text change events and update content
    this.quill.on("text-change", () => {
      this.content = this.quill.root.innerHTML; // Get the HTML content from the editor
    });

    // this.getContent(this.selectedLang, this.selectedCountry);

    // Ensure selectedCountry is valid after countries load
    if (!this.selectedCountry && this.countries.length) {
      this.selectedCountry = this.countries[0].code;
    }
    // Fetch existing content on mount
    // this.getContent();
  },
  methods: {
    async getCountries() {
      try {
        const response = await axios.get(`countries`, {
          headers: {
            "api-key": Cookies.get("authToken"),
          },
        });

        if (response.status === 200 && Array.isArray(response.data.countries)) {
          this.countries = response.data.countries;

          // 👇 ensure selected country exists
          if (
            !this.selectedCountry ||
            !this.countries.some((c) => c.code === this.selectedCountry)
          ) {
            this.selectedCountry = this.countries[0].code;
          }
        } else {
          this.countries = [];
        }
      } catch (error) {
        this.handleError(error);
      }
    },
    async getLanguages() {
      try {
        const response = await axios.get(`languages`, {
          headers: {
            "Content-Type": "multipart/form-data",
            "api-key": `${Cookies.get("authToken")}`,
          },
        });

        console.log(response);

        if (response.status == 200 && Array.isArray(response.data.languages)) {
          this.languages = response.data.languages;
        } else {
          this.languages = [];
        }
      } catch (error) {
        console.error("Error fetching languages:", error);
        if (error.status == 404) {
          this.$notify({
            message:
              error.response?.data?.message ||
              error.response?.data?.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 401) {
          this.$notify({
            message: error.response.data.error_message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          this.$router.push("/login");
          Cookies.remove("authToken");
        } else {
          this.$notify({
            message:
              error.response.data.error_message || error.response.data.message,
            icon: "",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    onLangChange() {
      this.getContent();
    },
    async getContent(lang, country) {
      try {
        const response = await axios.get(
          `/important/info?lang=${lang}&country=${country}`,
          {
            headers: {
              "api-key": `${Cookies.get("authToken")}`,
            },
          }
        );
        if (response.status == 200) {
          this.quill.root.innerHTML = response.data.content;
          this.content = response.data.content;
        }
      } catch (error) {
        if (error.status == 401) {
          this.$notify({
            message: "Sessionexpired, please login",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
          Cookies.remove("authToken");
          this.$router.push("/login");
        } else if (error.status == 404) {
          this.$notify({
            message: error.response.data.message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response.data.message || error.response.data.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      }
    },
    async updateContent() {
      if (!this.content) {
        this.$notify({
          message: "Please enter some content before updating",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      try {
        this.loading = true;
        const response = await axios.post(
          "/important/info",
          {
            content: this.content,
            language: this.selectedLang,
            country: this.selectedCountry,
          },
          {
            headers: {
              "api-key": `${Cookies.get("authToken")}`,
            },
          }
        );
        if (response.status == 201) {
          console.log("Content updated successfully.");
          this.$notify({
            message: "Content updated successfully.",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
        }
      } catch (error) {
        if (error.status == 401) {
          this.$notify({
            message: "Session expired, please login",
            icon: "add_alert",
            horizontalAlign: "top",
            verticalAlign: "right",
            type: "danger",
          });
          Cookies.remove("authToken");
          this.$router.push("/login");
        } else if (error.status == 404) {
          this.$notify({
            message: error.response.data.message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response.data.message || error.response.data.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async publishContent() {
      if (!this.content) {
        this.$notify({
          message: "Please enter some content before publishing",
          horizontalAlign: "right",
          verticalAlign: "top",
          type: "danger",
        });
        return;
      }

      try {
        this.loading = true;
        const response = await axios.post(
          "/important/info",
          {
            content: this.content,
            language: this.selectedLang,
            country: this.selectedCountry,
          },
          {
            headers: {
              "api-key": `${Cookies.get("authToken")}`,
            },
          }
        );
        if (response.status === 201) {
          this.$notify({
            message: "Content published successfully",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "success",
          });
          console.log("Content published successfully.");
        }
      } catch (error) {
        if (error.status == 401) {
          Cookies.remove("authToken");
          this.$router.push("/login");
          this.$notify({
            message: "Session expired, please login",
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else if (error.status == 404) {
          this.$notify({
            message: error.response.data.message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        } else {
          this.$notify({
            message:
              error.response.data.message || error.response.data.error_message,
            horizontalAlign: "right",
            verticalAlign: "top",
            type: "danger",
          });
        }
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.ckeditor {
  height: 60vh;
}
</style>
